module.exports = __webpack_public_path__ + "images/hoehenlinien-light-259f344329b8e8d9998758957eea8d78.png";